const Footer = () => {
    return (
        <footer className="footer footer-center p-4 bg-base-300 text-base-content">
            <div>
                <p>Copyright © 2023 - All right reserved by ninkachu.com </p>
            </div>
        </footer>
    )
}

export default Footer
